import script from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDetails.vue?vue&type=style&index=0&id=55dd52d9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dd52d9"]])

export default __exports__